import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    padding: 24,
    width: '80vw',
    boxSizing: 'border-box',
    borderRadius: theme.app.borderRadius.lg,
    maxWidth: theme.app?.breakpoints?.md || 960,
    background: theme.palette.background.default,

    [theme.breakpoints.down('sm')]: {
      width: '90vw'
    }
  },

  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  title: {
    color: theme.app.colors.text.primary,
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },

  headerBadge: {
    marginLeft: 16
  },

  content: {
    width: '100%',
    marginTop: 16,
    // minHeight: '20vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 0,

    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto',
      maxHeight: 'calc(90vh - 150px)'
    }
  },

  footerPopup: {
    borderTop: '1px solid #885D5D',
    display: 'flex',
    margin: '16px 0 0 0',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  containerButtons: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'flex-end',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  closeIcon: {
    color: '#000',
    fontSize: 24,
    cursor: 'pointer'
  }
}))
